<kpd-detail-entity-tabs
  [facade]="userFacade"
  [navigatorHelper]="navigatorHelper"
  (close)="onClose()"
  (itemChanged)="onItemChanged($event.item)"
  [updater]="entityUpdater"
  [viewMode]="viewMode"
  [entityTypeName]="'User' | translate"
  [showNavigation]="showNavigation"
  (tabChanged)="onTabChanged()"
  [demonstrativePronoun]="demonstrativePronoun"
>
  <kpd-detail-tab [title]="'General' | translate" name="general">
    <ng-template>
      <app-user-details-general
        [item]="currentItem"
        [updater]="entityUpdater"
        (switchMode)="onSwitchMode($event)"
        (itemChanged)="onItemChanged($event)"
      ></app-user-details-general>
    </ng-template>
  </kpd-detail-tab>
  <kpd-detail-tab
    [title]="'Licenses' | translate"
    name="licenses"
    icon="file-group"
    [badge]="tabLabels.licenseCount.toString()"
    [disabled]="currentItem?.isDeleted() || currentItem?.isNew()"
  >
    <ng-template>
      <app-user-details-licenses
        [item]="currentItem"
        (switchMode)="onSwitchMode($event)"
        (itemChanged)="changeTabLabel('licenseCount', $event)"
      ></app-user-details-licenses>
    </ng-template>
  </kpd-detail-tab>
  <kpd-detail-tab
    [title]="'Roles' | translate"
    name="roles"
    icon="users"
    [badge]="tabLabels.roleCount.toString()"
    [disabled]="currentItem?.isDeleted() || currentItem?.isNew()"
  >
    <ng-template>
      <app-user-details-roles
        [item]="currentItem"
        (switchMode)="onSwitchMode($event)"
        (itemChanged)="changeTabLabel('roleCount', $event)"
      >
      </app-user-details-roles>
    </ng-template>
  </kpd-detail-tab>

  <kpd-detail-tab
    [title]="'Permissions' | translate"
    name="permissions"
    icon="unlock"
    [disabled]="currentItem?.isDeleted() || currentItem?.isNew()"
    *kpdPermission="Permissions.UserRead"
  >
    <ng-template>
      <app-user-details-permissions [item]="currentItem" (switchMode)="onSwitchMode($event)">
      </app-user-details-permissions>
    </ng-template>
  </kpd-detail-tab>
</kpd-detail-entity-tabs>
